export const medicalTools = [

    /* =========================
       CƠ THỂ - CƠ BẢN
    ========================= */

    {
        slug: "bmi",
        name: "BMI",
        shortName: "BMI",
        group: "Cơ thể & cơ bản",
        description: "Tính chỉ số khối cơ thể từ cân nặng và chiều cao.",
        formula: "BMI = cân nặng (kg) / chiều cao² (m²)",
        fields: [
            { key: "weight", label: "Cân nặng", unit: "kg", type: "number" },
            { key: "height", label: "Chiều cao", unit: "cm", type: "number" }
        ]
    },

    {
        slug: "bsa-mosteller",
        name: "Diện tích bề mặt cơ thể",
        shortName: "BSA Mosteller",
        group: "Cơ thể & cơ bản",
        description: "Ước tính diện tích bề mặt cơ thể theo công thức Mosteller.",
        formula: "BSA = √[(chiều cao cm × cân nặng kg) / 3600]",
        fields: [
            { key: "weight", label: "Cân nặng", unit: "kg", type: "number" },
            { key: "height", label: "Chiều cao", unit: "cm", type: "number" }
        ]
    },

    {
        slug: "ibw-devine",
        name: "Cân nặng lý tưởng Devine",
        shortName: "IBW",
        group: "Cơ thể & cơ bản",
        description: "Ước tính cân nặng lý tưởng theo chiều cao và giới tính.",
        formula: "Nam: 50 + 2,3 kg/inch trên 5 ft. Nữ: 45,5 + 2,3 kg/inch trên 5 ft.",
        fields: [
            {
                key: "sex",
                label: "Giới tính",
                type: "select",
                options: [
                    { value: "male", label: "Nam" },
                    { value: "female", label: "Nữ" }
                ]
            },
            { key: "height", label: "Chiều cao", unit: "cm", type: "number" }
        ]
    },

    {
        slug: "adjusted-body-weight",
        name: "Cân nặng hiệu chỉnh",
        shortName: "AdjBW",
        group: "Cơ thể & cơ bản",
        description: "Tính cân nặng hiệu chỉnh từ cân nặng thực tế và IBW.",
        formula: "AdjBW = IBW + 0,4 × (Actual BW − IBW)",
        fields: [
            { key: "actualWeight", label: "Cân nặng thực tế", unit: "kg", type: "number" },
            { key: "idealWeight", label: "Cân nặng lý tưởng", unit: "kg", type: "number" }
        ]
    },


    /* =========================
       TIM MẠCH
    ========================= */

    {
        slug: "map",
        name: "Huyết áp động mạch trung bình",
        shortName: "MAP",
        group: "Tim mạch",
        description: "Ước tính mean arterial pressure từ huyết áp tâm thu và tâm trương.",
        formula: "MAP ≈ (SBP + 2 × DBP) / 3",
        fields: [
            { key: "sbp", label: "Huyết áp tâm thu", unit: "mmHg", type: "number" },
            { key: "dbp", label: "Huyết áp tâm trương", unit: "mmHg", type: "number" }
        ]
    },

    {
        slug: "pulse-pressure",
        name: "Hiệu áp",
        shortName: "Pulse Pressure",
        group: "Tim mạch",
        description: "Tính chênh lệch giữa huyết áp tâm thu và tâm trương.",
        formula: "PP = SBP − DBP",
        fields: [
            { key: "sbp", label: "Huyết áp tâm thu", unit: "mmHg", type: "number" },
            { key: "dbp", label: "Huyết áp tâm trương", unit: "mmHg", type: "number" }
        ]
    },

    {
        slug: "shock-index",
        name: "Shock Index",
        shortName: "SI",
        group: "Tim mạch",
        description: "Tỷ số giữa nhịp tim và huyết áp tâm thu.",
        formula: "Shock Index = HR / SBP",
        fields: [
            { key: "heartRate", label: "Nhịp tim", unit: "lần/phút", type: "number" },
            { key: "sbp", label: "Huyết áp tâm thu", unit: "mmHg", type: "number" }
        ]
    },


    /* =========================
       THẬN
    ========================= */

    {
        slug: "egfr-ckd-epi-2021",
        name: "eGFR CKD-EPI 2021",
        shortName: "eGFR",
        group: "Thận",
        description: "Ước tính mức lọc cầu thận ở người lớn theo CKD-EPI 2021 creatinine.",
        formula: "CKD-EPI 2021 creatinine, không dùng hệ số chủng tộc.",
        fields: [
            { key: "age", label: "Tuổi", unit: "năm", type: "number" },
            {
                key: "sex",
                label: "Giới tính",
                type: "select",
                options: [
                    { value: "male", label: "Nam" },
                    { value: "female", label: "Nữ" }
                ]
            },
            { key: "creatinine", label: "Creatinine huyết thanh", unit: "mg/dL", type: "number" }
        ]
    },

    {
        slug: "cockcroft-gault",
        name: "Creatinine Clearance Cockcroft–Gault",
        shortName: "CrCl",
        group: "Thận",
        description: "Ước tính độ thanh thải creatinine bằng cân nặng được nhập.",
        formula: "CrCl = (140 − tuổi) × cân nặng / (72 × SCr); ×0,85 nếu nữ.",
        fields: [
            { key: "age", label: "Tuổi", unit: "năm", type: "number" },
            { key: "weight", label: "Cân nặng sử dụng", unit: "kg", type: "number" },
            { key: "creatinine", label: "Creatinine", unit: "mg/dL", type: "number" },
            {
                key: "sex",
                label: "Giới tính",
                type: "select",
                options: [
                    { value: "male", label: "Nam" },
                    { value: "female", label: "Nữ" }
                ]
            }
        ]
    },

    {
        slug: "fena",
        name: "Fractional Excretion of Sodium",
        shortName: "FENa",
        group: "Thận",
        description: "Tính phân suất bài tiết natri.",
        formula: "FENa = (UNa × PCr) / (PNa × UCr) × 100",
        fields: [
            { key: "urineNa", label: "Na niệu", unit: "mmol/L", type: "number" },
            { key: "serumNa", label: "Na huyết thanh", unit: "mmol/L", type: "number" },
            { key: "urineCr", label: "Creatinine niệu", unit: "", type: "number" },
            { key: "serumCr", label: "Creatinine huyết thanh", unit: "", type: "number" }
        ]
    },

    {
        slug: "feurea",
        name: "Fractional Excretion of Urea",
        shortName: "FEUrea",
        group: "Thận",
        description: "Tính phân suất bài tiết ure.",
        formula: "FEUrea = (UUrea × PCr) / (PUrea × UCr) × 100",
        fields: [
            { key: "urineUrea", label: "Ure niệu", unit: "", type: "number" },
            { key: "serumUrea", label: "Ure huyết thanh", unit: "", type: "number" },
            { key: "urineCr", label: "Creatinine niệu", unit: "", type: "number" },
            { key: "serumCr", label: "Creatinine huyết thanh", unit: "", type: "number" }
        ]
    },


    /* =========================
       ĐIỆN GIẢI - CHUYỂN HÓA
    ========================= */

    {
        slug: "anion-gap",
        name: "Anion Gap",
        shortName: "AG",
        group: "Điện giải & chuyển hóa",
        description: "Tính khoảng trống anion từ Na, chloride và bicarbonate.",
        formula: "AG = Na − (Cl + HCO₃)",
        fields: [
            { key: "na", label: "Na", unit: "mmol/L", type: "number" },
            { key: "cl", label: "Cl", unit: "mmol/L", type: "number" },
            { key: "hco3", label: "HCO₃", unit: "mmol/L", type: "number" }
        ]
    },

    {
        slug: "corrected-calcium",
        name: "Calcium hiệu chỉnh theo albumin",
        shortName: "Corrected Ca",
        group: "Điện giải & chuyển hóa",
        description: "Ước tính calcium hiệu chỉnh khi calcium và albumin dùng đơn vị quy ước.",
        formula: "Corrected Ca = Ca + 0,8 × (4 − albumin)",
        fields: [
            { key: "calcium", label: "Calcium toàn phần", unit: "mg/dL", type: "number" },
            { key: "albumin", label: "Albumin", unit: "g/dL", type: "number" }
        ]
    },

    {
        slug: "serum-osmolality",
        name: "Áp lực thẩm thấu huyết thanh tính toán",
        shortName: "Calculated Osm",
        group: "Điện giải & chuyển hóa",
        description: "Tính serum osmolality từ Na, glucose và BUN.",
        formula: "2 × Na + glucose/18 + BUN/2,8",
        fields: [
            { key: "na", label: "Na", unit: "mmol/L", type: "number" },
            { key: "glucose", label: "Glucose", unit: "mg/dL", type: "number" },
            { key: "bun", label: "BUN", unit: "mg/dL", type: "number" }
        ]
    },

    {
        slug: "osmolar-gap",
        name: "Osmolar Gap",
        shortName: "Osm Gap",
        group: "Điện giải & chuyển hóa",
        description: "Chênh lệch giữa osmolality đo được và osmolality tính toán.",
        formula: "Osmolar gap = measured osmolality − calculated osmolality",
        fields: [
            { key: "measured", label: "Osmolality đo được", unit: "mOsm/kg", type: "number" },
            { key: "na", label: "Na", unit: "mmol/L", type: "number" },
            { key: "glucose", label: "Glucose", unit: "mg/dL", type: "number" },
            { key: "bun", label: "BUN", unit: "mg/dL", type: "number" }
        ]
    },


    /* =========================
       HÔ HẤP
    ========================= */

    {
        slug: "pf-ratio",
        name: "PaO₂/FiO₂ Ratio",
        shortName: "P/F Ratio",
        group: "Hô hấp",
        description: "Tính tỷ số PaO₂ trên FiO₂.",
        formula: "P/F = PaO₂ / FiO₂ (FiO₂ dạng thập phân)",
        fields: [
            { key: "pao2", label: "PaO₂", unit: "mmHg", type: "number" },
            { key: "fio2", label: "FiO₂", unit: "%", type: "number" }
        ]
    },

    {
        slug: "rox-index",
        name: "ROX Index",
        shortName: "ROX",
        group: "Hô hấp",
        description: "Tính ROX từ SpO₂, FiO₂ và tần số thở.",
        formula: "ROX = (SpO₂ / FiO₂) / RR",
        fields: [
            { key: "spo2", label: "SpO₂", unit: "%", type: "number" },
            { key: "fio2", label: "FiO₂", unit: "%", type: "number" },
            { key: "rr", label: "Tần số thở", unit: "lần/phút", type: "number" }
        ]
    },


    /* =========================
       ĐIỆN TÂM ĐỒ
    ========================= */

    {
        slug: "qtc-bazett",
        name: "QTc Bazett",
        shortName: "QTc Bazett",
        group: "Điện tâm đồ",
        description: "Hiệu chỉnh khoảng QT theo công thức Bazett.",
        formula: "QTc = QT / √RR",
        fields: [
            { key: "qt", label: "QT", unit: "ms", type: "number" },
            { key: "heartRate", label: "Nhịp tim", unit: "lần/phút", type: "number" }
        ]
    },

    {
        slug: "qtc-fridericia",
        name: "QTc Fridericia",
        shortName: "QTc Fridericia",
        group: "Điện tâm đồ",
        description: "Hiệu chỉnh khoảng QT theo công thức Fridericia.",
        formula: "QTc = QT / ∛RR",
        fields: [
            { key: "qt", label: "QT", unit: "ms", type: "number" },
            { key: "heartRate", label: "Nhịp tim", unit: "lần/phút", type: "number" }
        ]
    },


    /* =========================
       HUYẾT HỌC
    ========================= */

    {
        slug: "anc",
        name: "Absolute Neutrophil Count",
        shortName: "ANC",
        group: "Huyết học",
        description: "Tính số lượng bạch cầu trung tính tuyệt đối.",
        formula: "ANC = WBC × (% neutrophil + % band) / 100",
        fields: [
            { key: "wbc", label: "WBC", unit: "/µL", type: "number" },
            { key: "neutrophil", label: "Neutrophil", unit: "%", type: "number" },
            { key: "bands", label: "Band", unit: "%", type: "number", optional: true }
        ]
    },

    {
        slug: "nlr",
        name: "Neutrophil-to-Lymphocyte Ratio",
        shortName: "NLR",
        group: "Huyết học",
        description: "Tính tỷ số neutrophil/lymphocyte.",
        formula: "NLR = neutrophil / lymphocyte",
        fields: [
            { key: "neutrophil", label: "Neutrophil tuyệt đối", unit: "", type: "number" },
            { key: "lymphocyte", label: "Lymphocyte tuyệt đối", unit: "", type: "number" }
        ]
    },


    /* =========================
       GAN
    ========================= */

    {
        slug: "fib4",
        name: "FIB-4",
        shortName: "FIB-4",
        group: "Gan",
        description: "Tính chỉ số FIB-4 từ tuổi, AST, ALT và tiểu cầu.",
        formula: "FIB-4 = tuổi × AST / (platelet × √ALT)",
        fields: [
            { key: "age", label: "Tuổi", unit: "năm", type: "number" },
            { key: "ast", label: "AST", unit: "U/L", type: "number" },
            { key: "alt", label: "ALT", unit: "U/L", type: "number" },
            { key: "platelets", label: "Tiểu cầu", unit: "10⁹/L", type: "number" }
        ]
    },

    {
        slug: "apri",
        name: "APRI",
        shortName: "APRI",
        group: "Gan",
        description: "Tính AST to Platelet Ratio Index.",
        formula: "APRI = (AST / ULN AST) / platelet × 100",
        fields: [
            { key: "ast", label: "AST", unit: "U/L", type: "number" },
            { key: "astUln", label: "Giới hạn trên AST của labo", unit: "U/L", type: "number" },
            { key: "platelets", label: "Tiểu cầu", unit: "10⁹/L", type: "number" }
        ]
    },


    /* =========================
       THẦN KINH - CẤP CỨU
    ========================= */

    {
        slug: "gcs",
        name: "Glasgow Coma Scale",
        shortName: "GCS",
        group: "Thần kinh & cấp cứu",
        description: "Ghi nhận đáp ứng mắt, lời nói và vận động.",
        formula: "GCS = E + V + M",
        fields: [
            {
                key: "eye",
                label: "Đáp ứng mắt (E)",
                type: "select",
                options: [
                    { value: "4", label: "4 - Tự mở mắt" },
                    { value: "3", label: "3 - Đáp ứng âm thanh" },
                    { value: "2", label: "2 - Đáp ứng áp lực" },
                    { value: "1", label: "1 - Không đáp ứng" }
                ]
            },
            {
                key: "verbal",
                label: "Đáp ứng lời nói (V)",
                type: "select",
                options: [
                    { value: "5", label: "5 - Định hướng tốt" },
                    { value: "4", label: "4 - Lú lẫn" },
                    { value: "3", label: "3 - Từ không phù hợp" },
                    { value: "2", label: "2 - Âm thanh không hiểu được" },
                    { value: "1", label: "1 - Không đáp ứng" }
                ]
            },
            {
                key: "motor",
                label: "Đáp ứng vận động (M)",
                type: "select",
                options: [
                    { value: "6", label: "6 - Làm theo lệnh" },
                    { value: "5", label: "5 - Định vị kích thích" },
                    { value: "4", label: "4 - Co rút bình thường" },
                    { value: "3", label: "3 - Gấp bất thường" },
                    { value: "2", label: "2 - Duỗi bất thường" },
                    { value: "1", label: "1 - Không đáp ứng" }
                ]
            }
        ]
    },

    {
        slug: "qsofa",
        name: "qSOFA",
        shortName: "qSOFA",
        group: "Thần kinh & cấp cứu",
        description: "Ba tiêu chí bedside ở người lớn có nghi ngờ nhiễm trùng.",
        formula: "RR ≥22; SBP ≤100; thay đổi tri giác. Mỗi tiêu chí 1 điểm.",
        fields: [
            { key: "rr", label: "Tần số thở", unit: "lần/phút", type: "number" },
            { key: "sbp", label: "Huyết áp tâm thu", unit: "mmHg", type: "number" },
            {
                key: "alteredMentation",
                label: "Thay đổi tri giác",
                type: "select",
                options: [
                    { value: "no", label: "Không" },
                    { value: "yes", label: "Có" }
                ]
            }
        ]
    },

    {
        slug: "curb65",
        name: "CURB-65",
        shortName: "CURB-65",
        group: "Hô hấp",
        description: "Ghi nhận năm tiêu chí CURB-65 ở viêm phổi người lớn.",
        formula: "Confusion, Urea, RR, Blood pressure, Age ≥65.",
        fields: [
            { key: "age", label: "Tuổi", unit: "năm", type: "number" },
            { key: "urea", label: "Ure", unit: "mmol/L", type: "number" },
            { key: "rr", label: "Tần số thở", unit: "lần/phút", type: "number" },
            { key: "sbp", label: "Huyết áp tâm thu", unit: "mmHg", type: "number" },
            { key: "dbp", label: "Huyết áp tâm trương", unit: "mmHg", type: "number" },
            {
                key: "confusion",
                label: "Lú lẫn mới xuất hiện",
                type: "select",
                options: [
                    { value: "no", label: "Không" },
                    { value: "yes", label: "Có" }
                ]
            }
        ]
    },


    /* =========================
       CHUYỂN ĐỔI ĐƠN VỊ
    ========================= */

    {
        slug: "creatinine-converter",
        name: "Đổi đơn vị Creatinine",
        shortName: "Creatinine",
        group: "Chuyển đổi",
        description: "Đổi creatinine giữa mg/dL và µmol/L.",
        formula: "1 mg/dL ≈ 88,4 µmol/L",
        fields: [
            { key: "value", label: "Giá trị", unit: "", type: "number" },
            {
                key: "direction",
                label: "Chuyển đổi",
                type: "select",
                options: [
                    { value: "mg-to-umol", label: "mg/dL → µmol/L" },
                    { value: "umol-to-mg", label: "µmol/L → mg/dL" }
                ]
            }
        ]
    },

    {
        slug: "glucose-converter",
        name: "Đổi đơn vị Glucose",
        shortName: "Glucose",
        group: "Chuyển đổi",
        description: "Đổi glucose giữa mg/dL và mmol/L.",
        formula: "mmol/L ≈ mg/dL ÷ 18",
        fields: [
            { key: "value", label: "Giá trị", unit: "", type: "number" },
            {
                key: "direction",
                label: "Chuyển đổi",
                type: "select",
                options: [
                    { value: "mg-to-mmol", label: "mg/dL → mmol/L" },
                    { value: "mmol-to-mg", label: "mmol/L → mg/dL" }
                ]
            }
        ]
    },

    {
        slug: "temperature-converter",
        name: "Đổi °C / °F",
        shortName: "Nhiệt độ",
        group: "Chuyển đổi",
        description: "Chuyển đổi nhiệt độ Celsius và Fahrenheit.",
        formula: "°F = °C × 9/5 + 32",
        fields: [
            { key: "value", label: "Nhiệt độ", unit: "", type: "number" },
            {
                key: "direction",
                label: "Chuyển đổi",
                type: "select",
                options: [
                    { value: "c-to-f", label: "°C → °F" },
                    { value: "f-to-c", label: "°F → °C" }
                ]
            }
        ]
    },

    {
        slug: "weight-converter",
        name: "Đổi kg / lb",
        shortName: "Khối lượng",
        group: "Chuyển đổi",
        description: "Chuyển đổi kilogram và pound.",
        formula: "1 kg ≈ 2,20462 lb",
        fields: [
            { key: "value", label: "Khối lượng", unit: "", type: "number" },
            {
                key: "direction",
                label: "Chuyển đổi",
                type: "select",
                options: [
                    { value: "kg-to-lb", label: "kg → lb" },
                    { value: "lb-to-kg", label: "lb → kg" }
                ]
            }
        ]
    }
];


export const medicalGroups = [
    "Tất cả",
    "Cơ thể & cơ bản",
    "Tim mạch",
    "Thận",
    "Điện giải & chuyển hóa",
    "Hô hấp",
    "Điện tâm đồ",
    "Huyết học",
    "Gan",
    "Thần kinh & cấp cứu",
    "Chuyển đổi"
];


export const getMedicalTool = (slug) =>
    medicalTools.find((item) => item.slug === slug);
